import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const FinancialPOA = () => {
  const {
    register,
    watch
  } = useFormContext();
  const [primaryAttorneys, setPrimaryAttorneys] = useState([{
    id: 1
  }]);
  const [alternateAttorneys, setAlternateAttorneys] = useState([{
    id: 1
  }]);
  const addPrimaryAttorney = () => {
    const newId = primaryAttorneys.length > 0 ? Math.max(...primaryAttorneys.map(a => a.id)) + 1 : 1;
    setPrimaryAttorneys([...primaryAttorneys, {
      id: newId
    }]);
  };
  const removePrimaryAttorney = (id: number) => {
    setPrimaryAttorneys(primaryAttorneys.filter(a => a.id !== id));
  };
  const addAlternateAttorney = () => {
    const newId = alternateAttorneys.length > 0 ? Math.max(...alternateAttorneys.map(a => a.id)) + 1 : 1;
    setAlternateAttorneys([...alternateAttorneys, {
      id: newId
    }]);
  };
  const removeAlternateAttorney = (id: number) => {
    setAlternateAttorneys(alternateAttorneys.filter(a => a.id !== id));
  };
  return <div className="space-y-8" data-id="element-707">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-708">
        <p className="text-slate-700" data-id="element-709">
          A Power of Attorney for Property gives someone else the legal
          authority to make decisions about your finances and property if you
          become unable to make these decisions yourself.
        </p>
      </div>

      {/* Primary Attorneys */}
      <div className="space-y-4" data-id="element-710">
        <div className="flex justify-between items-center" data-id="element-711">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-712">
            Primary Attorney(s) for Property
          </h3>
          <button type="button" onClick={addPrimaryAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-713">
            <PlusIcon size={16} className="mr-1" data-id="element-714" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-715">
          <p className="text-sm text-blue-800" data-id="element-716">
            You may name one or more Primary Attorneys. If you name multiple
            attorneys, you will need to specify whether they should act jointly
            (together) or independently (separately).
          </p>
        </div>

        {primaryAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-717">
            <div className="flex justify-between items-center mb-3" data-id="element-718">
              <h4 className="font-medium" data-id="element-719">Primary Attorney {index + 1}</h4>
              {primaryAttorneys.length > 1 && <button type="button" onClick={() => removePrimaryAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-720">
                  <TrashIcon size={16} data-id="element-721" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-722">
              <div data-id="element-723">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-724">
                  Name
                  <span className="text-red-500 ml-1" data-id="element-725">*</span>
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter attorney's name" {...register(`financialPOA.primary.${index}.name`)} data-id="element-726" />
              </div>
              <div data-id="element-727">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-728">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register(`financialPOA.primary.${index}.relationship`)} data-id="element-729" />
              </div>
              <div data-id="element-730">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-731">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`financialPOA.primary.${index}.phone`)} data-id="element-732" />
              </div>
            </div>
            <div className="mt-4" data-id="element-733">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-734">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter attorney's address" {...register(`financialPOA.primary.${index}.address`)} data-id="element-735" />
            </div>
          </div>)}

        {/* Joint or Independent - only show if multiple primary attorneys */}
        {primaryAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-736">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-737">
              Should your primary attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-738">
              <label className="flex items-start" data-id="element-739">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('financialPOA.primaryActing')} data-id="element-740" />
                <span className="ml-2 block" data-id="element-741">
                  <span className="font-medium" data-id="element-742">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-743">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-744">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('financialPOA.primaryActing')} data-id="element-745" />
                <span className="ml-2 block" data-id="element-746">
                  <span className="font-medium" data-id="element-747">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-748">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>

      {/* Alternate Attorneys */}
      <div className="space-y-4" data-id="element-749">
        <div className="flex justify-between items-center" data-id="element-750">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-751">
            Alternate Attorney(s) for Property
          </h3>
          <button type="button" onClick={addAlternateAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-752">
            <PlusIcon size={16} className="mr-1" data-id="element-753" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-754">
          <p className="text-sm text-blue-800" data-id="element-755">
            Alternate attorneys will act if your primary attorney(s) are unable
            or unwilling to act. You may name one or more alternates.
          </p>
        </div>

        {alternateAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-756">
            <div className="flex justify-between items-center mb-3" data-id="element-757">
              <h4 className="font-medium" data-id="element-758">Alternate Attorney {index + 1}</h4>
              {alternateAttorneys.length > 1 && <button type="button" onClick={() => removeAlternateAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-759">
                  <TrashIcon size={16} data-id="element-760" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-761">
              <div data-id="element-762">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-763">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate attorney's name" {...register(`financialPOA.alternate.${index}.name`)} data-id="element-764" />
              </div>
              <div data-id="element-765">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-766">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register(`financialPOA.alternate.${index}.relationship`)} data-id="element-767" />
              </div>
              <div data-id="element-768">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-769">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`financialPOA.alternate.${index}.phone`)} data-id="element-770" />
              </div>
            </div>
            <div className="mt-4" data-id="element-771">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-772">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter alternate attorney's address" {...register(`financialPOA.alternate.${index}.address`)} data-id="element-773" />
            </div>
          </div>)}

        {/* Joint or Independent for alternates - only show if multiple alternate attorneys */}
        {alternateAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-774">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-775">
              Should your alternate attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-776">
              <label className="flex items-start" data-id="element-777">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('financialPOA.alternateActing')} data-id="element-778" />
                <span className="ml-2 block" data-id="element-779">
                  <span className="font-medium" data-id="element-780">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-781">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-782">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('financialPOA.alternateActing')} data-id="element-783" />
                <span className="ml-2 block" data-id="element-784">
                  <span className="font-medium" data-id="element-785">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-786">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>

      {/* When POA Takes Effect */}
      <div className="space-y-4" data-id="element-787">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-788">
          When Should the Power of Attorney Take Effect?
        </h3>

        <div data-id="element-789">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-790">
            Do you want the POA to be effective immediately or only upon
            incapacity?
          </label>
          <div className="space-y-3" data-id="element-791">
            <label className="flex items-start p-3 border border-slate-200 rounded-md hover:bg-slate-50" data-id="element-792">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="uponIncapacity" {...register('financialPOA.effectiveDate')} data-id="element-793" />
              <span className="ml-3 block" data-id="element-794">
                <span className="font-medium" data-id="element-795">
                  Upon incapacity only (Standard/Recommended)
                </span>
                <span className="text-sm text-slate-600 block mt-1" data-id="element-796">
                  The POA will only take effect upon a medical professional
                  adjudging in writing that you are incapable of managing your
                  own affairs. This is the standard approach.
                </span>
              </span>
            </label>
            <label className="flex items-start p-3 border border-slate-200 rounded-md hover:bg-slate-50" data-id="element-797">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="immediately" {...register('financialPOA.effectiveDate')} data-id="element-798" />
              <span className="ml-3 block" data-id="element-799">
                <span className="font-medium" data-id="element-800">Effective immediately</span>
                <span className="text-sm text-slate-600 block mt-1" data-id="element-801">
                  The POA will be effective immediately upon signing. Your
                  attorney can act on your behalf right away, even while you are
                  capable.
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>;
};
export default FinancialPOA;